
export default {
  USER_ROLES: {
    UNKNOWN: 'unknown',
    GUEST: 'guest',
    BOARD_OF_DIRECTOR: 'board_of_director',
    MAA_STAFF: 'maa_staff',
    ADMINISTRATOR: 'administrator',
    SUPER_ADMINISTRATOR: 'super_administrator'
  },
  USER_ROLE_RANK: ['unknown', 'guest', 'board_of_director', 'maa_staff', 'administrator', 'super_administrator'],
  hasRole (userRole, necessaryRole) {
    const userRoleIndex = this.USER_ROLE_RANK.indexOf(userRole)
    const necessaryRoleIndex = this.USER_ROLE_RANK.indexOf(necessaryRole)
    if (userRoleIndex === -1 || necessaryRoleIndex === -1) {
      return false
    }
    return necessaryRoleIndex <= userRoleIndex
  }
}
// Test comment


// WEBPACK FOOTER //
// ./src/UserRoles.js